import React from 'react'
import FooterButtons from 'components/inputs/Material/FooterButtons/index'
import Info from 'components/inputs/Material/Info/index'
import { FormFieldsContainer } from '../Shared/styles'

export default function FlexBlockEntry() {
  return (
    <>
      <FormFieldsContainer>
        <Info />
      </FormFieldsContainer>
      <FooterButtons showLogicButton={false} />
    </>
  )
}
